module.exports = __webpack_public_path__ + "static/media/COS_ELANCO.21ff2e29.webp";